import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppBar, Dialog, Icon, IconButton, Toolbar, Typography } from '@mui/material'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Conditions({ classes, handleClose, open, type }) {
	const navigate = useNavigate()
	const shop = useSelector(state => state.shop)

	return (<Dialog fullScreen open={open} onClose={handleClose}>
		<AppBar className={classes.appBar}>
			<Toolbar>
				<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
					<Icon>cancel</Icon>
				</IconButton>
				{type == 'privacy_text' ? 'Informativa sulla privacy' : 'Condizioni di vendita'}
			</Toolbar>
		</AppBar>
		<div
			className={classes.page}
			style={{ marginBottom: 0, padding: 20 }}
			dangerouslySetInnerHTML={{
				__html: shop.informations[type]
			}}
		/>
	</Dialog>)
}

export default withStyles(style)(Conditions)
